<template>
    <div>
        <el-dialog class="dialogDiv" :close-on-click-modal="false" :modal-append-to-body='false' :title="dialogTitle" :visible.sync="tobSubDialogVisible" :before-close="handleCloseDialog">
            <div class="mt20">
                <el-input placeholder="主体名、负责人、联系方式" class="w300 seekIpt" v-model="searchInput" @keyup.enter.native="search">
                    <i slot="suffix" class="el-input__icon el-icon-search" @click="search"></i>
                </el-input>
                <el-cascader class="ml20 w300" v-model="areaId" :options="areaList.options" @change="areaChange" :props="areaList.props" clearable placeholder="所属行政区" ref="cascader"></el-cascader>
            </div>
            <div style="margin-top: 10px;">
                <el-table :data="tableData" highlight-current-row @current-change="handleCurrentChange" border height="550" :cell-style="{'text-align': 'center'}" :header-cell-style="{'text-align': 'center'}" v-loading="tableLoading">
                    <el-table-column label="序号" width="80" type=index >
                        <template slot-scope="scope">
                            {{(page.pageSize * (page.pageNum - 1) + scope.$index + 1)}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="buyerName" label="主体名" min-width="200" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{scope.row.buyerName ? scope.row.buyerName: '-'}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="legalPerson" label="负责人" min-width="150" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{scope.row.legalPerson ? scope.row.legalPerson: '-'}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="tel" label="联系电话" min-width="150" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{scope.row.tel ? scope.row.tel: '-'}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="buyerType" label="行业类型" min-width="100" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{scope.row.buyerType ? scope.row.buyerType: '-'}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="address" label="经营地址/场所地址" min-width="200" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{scope.row.address ? scope.row.address: '-'}}
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <ybPagination :page="page" @size-change="pageSizeChange" @current-change="pageCurrentChange" style="margin-top:10px; margin-right: 100px;"></ybPagination>
            <div class="footer">
                <el-button @click="cancle" round>取消</el-button>
                <el-button type="primary" @click="bind" round>绑定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import * as subManageApi from '@/api/subManage'
import * as mapping from '@/utils/enumList'
import ybPagination from '@/components/ybPagination'
export default {
    name: 'TobSubDialog',
    components: {
        ybPagination
    },
    data() {
        return {
            dialogTitle: '选择TOB主体',
            dialogVisible: false,
            searchInput: '',
            tableData: [],
            parentId: '0',
            areaId: '',
            areaList: {
                selectedOptions: [],
                options: [],
                parentCode: '',
                props: {
                    checkStrictly: true,
                    expandTrigger: 'hover',
                    value: 'areaId',
                    label: 'areaName',
                    children: 'children',
                    lazy: true,
                    lazyLoad(node, resolve) {}
                }
            },
            tableLoading: false,
            page: {
                pageSize: 10,
                pageNum: 1,
                total: 0
            },
            bindParams: {}
        }
    },
    props: {
        tobSubDialogVisible: {
            required: true,
            type: Boolean
        },
        hasAdmin: {
            required: true,
            type: Boolean
        }
    },
    computed: {
      queryListParams: function(){
        return {
          areaId: this.areaList.selectedOptions[this.areaList.selectedOptions.length - 1],
          current: this.page.pageNum,
          keyword: this.searchInput,
          size: this.page.pageSize
        }
      }
    },
    methods: {
        search() {
            this.page.pageNum = 1;
            this.tableRefresh();
        },
        // 点击区域节点前的圆圈进行选择
        areaChange(val) {
            this.page.pageNum = 1;
            this.areaList.selectedOptions = val;
            this.tableRefresh();
        },
        // 列表行选中
        handleCurrentChange(row) {
            this.bindParams = {}
            if(!row) return
            this.bindParams = row
            // this.bindParams.entityId = this.togSubData.entityId
            // this.bindParams.togEntityType = row.entityType
            // this.bindParams.togId = row.id
            // this.bindParams.togLicense = row.licence
            // this.bindParams.togName = row.entityName
            // this.bindParams.togCreditCode = row.creditCode
        },
        tableRefresh() {
            this.tableLoading = true
            subManageApi.tobExpectBindSub(this.queryListParams).then(r => {
                if(r.code === 200) {
                    let data = r.data.records
                    data.forEach(el => {
                        el.buyerType = mapping.keyToVal('buyerType', el.buyerType)
                    })
                    this.tableData = data
                    this.page.total = parseInt(r.data.total)
                }
                this.tableLoading = false;
            }).catch(err => {})
        },
        // 页数改变
        pageCurrentChange(num) {
            if(num !== this.page.pageNum) {
                this.page.pageNum = num;
                this.tableRefresh();
            }
        },
        // 页数据量改变
        pageSizeChange(size) {
            this.page.pageNum = 1
            if(size !== this.page.pageSize) {
                this.page.pageSize = size;
                this.tableRefresh();
            }
        },
        bind() {
            if(!this.bindParams) {
                this.$message.warning('请点击列表,选择对应的主体后再绑定')
            } else {
                if(this.$parent.subjectAdd) {
                    this.$confirm('绑定会覆盖已经填写的部分内容, 是否确定?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning',
                        closeOnClickModal: false,
                        distinguishCancelAndClose: true
                    }).then(() => {
                        this.isSyncFromSubject()
                    }).catch(e => {
                        // 关闭弹框
                        if(e === 'close') return 
                        // 不同步
                        this.$parent.tobSubDialogVisible = false
                    })
                } else {
                    this.isSyncFromSubject()
                }
                // if(this.bindParams.buyerType !== '社会餐饮') {
                //     this.$message.warning('仅能绑定餐饮主体')                    
                // } else {
                //        this.isSyncFromSubject()
                // }
            }
        },
        isSyncFromSubject() {
            this.$confirm('是否从TOB主体同步待添加字段？', '提示', {
                confirmButtonText: '同步',
                cancelButtonText: '不同步',
                type: 'warning',
                closeOnClickModal: false,
                distinguishCancelAndClose: true
            }).then(() => {
                if(this.hasAdmin) { // 已经编辑了管理员账号和密码
                    this.adminSync()
                } else {
                    this.$emit('tobSubData', this.bindParams)
                    this.$emit('isTobSync', true)
                    this.$parent.tobSubDialogVisible = false
                }
            }).catch(e => {
                // 关闭弹框
                if(e === 'close') return 
                // 不同步
                this.$emit('tobSubData', this.bindParams)
                this.$emit('isTobSync', false)
                this.$parent.tobSubDialogVisible = false
            })
        },
        adminSync() {
          this.$confirm('是否同步管理员账号及密码？', '提示', {
              confirmButtonText: '同步',
              cancelButtonText: '不同步',
              type: 'warning',
              closeOnClickModal: false,
              distinguishCancelAndClose: true
          }).then(() => {
              this.$emit('tobSubData', this.bindParams)
              this.$emit('isTobSync', true)
              this.$emit('isAdminSync', true)
              this.$parent.tobSubDialogVisible = false
          }).catch(e => {
              // 关闭弹框
              if(e === 'close') return 
              // 不同步
              this.$emit('tobSubData', this.bindParams)
              this.$emit('isTobSync', true)
              this.$emit('isAdminSync', false)
              this.$parent.tobSubDialogVisible = false
          })
        },
        cancle() {
            this.handleCloseDialog();
        },
        handleCloseDialog() {
            this.$emit('closeTobSubDialog');
        }
    },
    created() {
      let that = this;
      that.areaList.props.lazyLoad = function (node, resolve) {
          let code = node.value ? node.value : that.parentId;
          if (code.length > 6) { 
              return resolve([]) 
          }
          subManageApi.getAreaList({parentId: code}).then(r => {
              if (r.code === 200) {
                  resolve(r.data)
              }
          });
      }
      this.tableRefresh()
    }
}
</script>

<style lang="scss" scoped>
    .dialogDiv {
      text-align: left;
      // .el-table {
      //   height: 550px;
      //   overflow-y: auto;
      // }
    }
    .dialogDiv::v-deep .el-dialog{
      width: 1000px;
    }
    .footer {
      margin-top: 20px;
      text-align: right;
    }
</style>